import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, ResolveFn, Router } from '@angular/router';
import { EMPTY, finalize, first } from 'rxjs';
import { ShiftResponse, ShiftsClient } from '../../shared';
import { LoadingDefaults } from '../../shared/models/loading-defaults.model';
import { RplLoadingService } from '../../shared/services/rpl-loading.service';

export const shiftResolver: ResolveFn<ShiftResponse> = (
  route: ActivatedRouteSnapshot,
) => {
  const client = inject(ShiftsClient);
  const loadingService = inject(RplLoadingService);
  const router = inject(Router);

  const shiftId = Number(route.paramMap.get('shiftId'));

  if (Number.isNaN(shiftId)) {
    void router.navigate(['shifts']);
    return EMPTY;
  }

  let loadingId: string | undefined;
  const timeout = setTimeout(() => {
    loadingId = loadingService.start();
  }, LoadingDefaults.StartIndicatorTimeout);

  return client.getShiftById(shiftId).pipe(
    first(),
    finalize(() => {
      clearTimeout(timeout);
      loadingService.end(loadingId);
    }),
  );
};
